export enum ECivilianFlightCFITypes {
  CFI = 'CFI',
  CFII = 'CFII',
  MEI = 'MEI',
  NONE = 'NONE'
}
